import { computed, watch, reactive } from 'vue';
import { uuid } from 'vue-uuid';
export default {
  components: {},
  props: {
    value: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: 9999,
    },
    placeholder: {
      type: String,
      default: '',
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    bg: {
      type: String,
      default: 'default',
    },
    id: {
      type: String,
      default: '',
    }
  },
  setup(props, { emit }) {
    const { value, bg, id } = props;
    const state = reactive({
      errorStyle: '',
      disableStyle: '',
    })

    const styleClass = computed(() => [
      bg,
    ])

    const privateValue = computed({
      get: () => value,
      set: (val) => {
        emit('update:value', val);
      }
    });

    const privateId = computed(() => {
      return id === '' ? uuid.v4() : id;
    })

    watch(
      () => props.isError,
      (val) => {
        state.errorStyle = val ? 'style--error' : '';
      })

    watch(
      () => props.isDisable,
      (val) => {
        state.disableStyle = val ? 'style--disable' : '';
      })

    return {
      privateValue,
      state,
      styleClass,
      privateId
    }


  }
}


